import Echo from 'laravel-echo';

import Pusher from 'pusher-js';
window.Pusher = Pusher;



window.Echo = new Echo({
    broadcaster: 'reverb',
    authEndpoint: '/api/broadcasting/auth',
    key: import.meta.env.VITE_REVERB_APP_KEY,
    wsHost: import.meta.env.VITE_REVERB_HOST,
    wsPort: import.meta.env.VITE_REVERB_PORT ?? 443,
    wssPort: import.meta.env.VITE_REVERB_PORT ?? 443,
    forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
    scheme: 'https', // Use 'https' as the scheme to enable secure WebSockets
    enabledTransports: ['ws', 'wss'],
});
